export const applyConciliationAdjustment = (payload, adjustment) => {
  const ajuste = Number(adjustment)
  if (ajuste !== 245 && ajuste !== 326) return payload

  return {
    ...payload,
    ajuste
  }
}
